import { Location, matchRoutes } from "react-router-dom"
import { AppRouteConfig } from "@/types/navigation"
import routes from "@/routes"
import errorRoutes from "@/routes/error"

export const getCurrentRouteContext = (location: Location): AppRouteConfig => {
  const matches = matchRoutes(routes, location)

  if (matches === null) {
    return errorRoutes[0]
  }

  return matches[0].route
}

/**
 * Get the redirect URL from search parameters or return a default
 * @param searchParams - URLSearchParams object
 * @param defaultPath - Default path to redirect to if no redirect param
 * @returns The redirect URL or default path
 */
export const getRedirectUrl = (searchParams: URLSearchParams, defaultPath: string): string => {
  const redirectTo = searchParams.get("redirect")
  if (redirectTo) {
    return decodeURIComponent(redirectTo)
  }
  return defaultPath
}
